<template>

    <div class="content-overlay n-plan">

        <div class="in-content" :class="{ clsng : Global.tempClosingOverlay }">

            <div class="head">
                <h5>
                    <span class="txt-grt">New subscription plan</span>
                </h5>
                <span class="x" @click.prevent="closePlanOverlay">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
                    <path d="M19.4706 2.5L2.5 19.4706" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    <path d="M19.4706 19.4706L2.5 2.5" stroke="white" stroke-width="3" stroke-linecap="square"/>
                    </svg>
                </span>
            </div>

            <div class="inner-content">
                <div class="lft">
                    <div class="col">
                        <p class="step-caption ft-bld">Enter information for your new plan</p>
                        <InputWrapper placeholder="Plan name" v-model="Global.newPlanOverlay.name" :max-chars="12"></InputWrapper>
                        <ToggleWrapper caption="Subscription model" :items="['Monthly & yearly', 'Monthly only', 'Yearly only']"
                            @input="onPresetChange">
                        </ToggleWrapper>
                        <InputWrapper placeholder="Monthly billed price" v-model="Global.newPlanOverlay.monthlyPrice" 
                            v-show="model == 'both' || model == 'monthly'"
                            :max-chars="8" 
                            hasPriceTag 
                            price-tag-period="month" 
                        ></InputWrapper>
                        <InputWrapper placeholder="Yearly billed price" v-model="Global.newPlanOverlay.yearlyPrice" 
                            v-show="model == 'both' || model == 'annualy'"
                            :max-chars="8" 
                            hasPriceTag 
                            price-tag-period="year" 
                        ></InputWrapper>
                        <SliderWrapper caption="Number of trial day(s)" :starting-num="30" :range-min="0" :range-max="90" @updateSlider="updateBorderRadius"></SliderWrapper>
                        <div class="nxt-out" @click.prevent="submit">
                            <div class="btn main txt-blk">
                                <span class="hvr"></span>
                                <span class="txt">Create my plan</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col rgt">
                    <p class="step-caption ft-bld">Preview of your content</p>
                    <PlanCard :plan="Global.newPlanOverlay"></PlanCard>
                </div>
            </div>
            
        </div>
        
    </div>

</template>

<script>

    import PlanCard from './PlanCard'
    import Global from '../lib/GlobalState'
    import InputWrapper from '../components/InputWrapper'
    import ToggleWrapper from '../components/ToggleWrapper'
    import SliderWrapper from '../components/SliderWrapper'

    export default {

        name: 'PlanOverlay',

        components: {
            PlanCard,
            InputWrapper,
            ToggleWrapper,
            SliderWrapper
        },

        props: {
            
        },

        data() {
            return {
                Global,
                model: 'both'
            }
        },


        methods: {

            onPresetChange(e) {
                if(e === 0)
                    this.model = 'both'
                if(e === 1)
                    this.model = 'monthly'
                if(e === 2)
                    this.model = 'annualy'

                this.Global.newPlanOverlay.model = this.model
            },

            updateBorderRadius(value) {
                this.Global.newPlanOverlay.freeDays = value
            },
            
            closePlanOverlay() {
                const p = new Promise((resolve) => {
                    this.Global.tempClosingOverlay = true
                    setTimeout(() => { this.Global.activeBlurredOverlay = false }, 300)
                    setTimeout(() => { 
                        this.Global.activePlanOverlay = false 
                        resolve()
                    }, 600)
                })

                // Return To Content
                if(this.Global.returnToContent == true) {
                    p.then(() => {
                        this.$parent.openContentOverlay()
                    })
                }

                return p
            },

            submit() {

                this.Global.plans.splice(1,0,{
                    name: this.Global.newPlanOverlay.name,
                    description: "All our content, ad-free, offline, and in the background",
                    model: this.Global.newPlanOverlay.model,
                    monthlyPrice: this.priceToFloat(this.Global.newPlanOverlay.monthlyPrice),
                    yearlyPrice: this.priceToFloat(this.Global.newPlanOverlay.yearlyPrice),
                    freeDays: this.Global.newPlanOverlay.freeDays,
                    selected: false
                })
                
                this.closePlanOverlay().then(() => {
                    this.resetForm()
                })
            },

            resetForm() {
                this.Global.newPlanOverlay.name = null
                this.Global.newPlanOverlay.monthlyPrice = null
                this.Global.newPlanOverlay.yearlyPrice = null
                this.Global.newPlanOverlay.freeDays = 30
            },

            priceToFloat(price) {
                if(!price) return null
                price = price.replace(/,/g, ".")
                price = price.replace(/[^1234567890.]+/g, "")
                return price === "" ? null : parseFloat(price)
            }
        }
    }
</script>